'use client';

import React from 'react';

const BRAND = 'Top14';

/**
 * Renders copy with every literal "Top14" wrapped in <strong> (for homepage / marketing).
 */
export function BrandText({ text, className }: { text: string; className?: string }) {
  const parts = text.split(new RegExp(`(${BRAND})`, 'g'));
  return (
    <span className={className}>
      {parts.map((part, i) =>
        part === BRAND ? (
          <strong key={i} className="font-bold">
            {part}
          </strong>
        ) : (
          <span key={i}>{part}</span>
        ),
      )}
    </span>
  );
}
